import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import { UsuarioReducer } from "./LoginReducer";
import thunk from "redux-thunk";
import { SesionReducer } from "./SesionReducer";
import { LoadingReducer } from "./LoadingReducer";
import { ClientesearchReducer } from "./ClientesearReducer";
import { ClimaReducer } from "./ClimaReducer";
import { NotificationReducer } from "./NotificationReducer";
import { GlobalStateReducer } from "./GlobalStateReducer";

const composeEnhancers =
  (typeof window !== "undefined" &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;

const reducers = combineReducers({
  sesion: SesionReducer,
  usuario: UsuarioReducer,
  loading: LoadingReducer,
  clientes: ClientesearchReducer,
  clima: ClimaReducer,
  notifications: NotificationReducer,
  globalState: GlobalStateReducer
});

export const store = createStore(
  reducers,
  composeEnhancers(applyMiddleware(thunk))
);
